import React, { useEffect, useRef, useState } from 'react';
import './copy-to-games-modal.styles.scss';
import Modal, { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import { useSelector } from 'react-redux';
import { getRegsFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import ImageContainer from '../image-container/image-container.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import FullPageLoader from '@/components/loader/full-page-loader.component';

const CopyToGamesModal = ({
  show,
  cancel,
  element,
  gameElements
}) => {

  const membership = useSelector(state => state.userData.membership);
  const userProfile = useSelector(state => state.userData.userProfile);
  const [ gameList, setGameList ] = useState({});
  const [ selectedGames, setSelectedGames ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [ alertMessage, setAlertMessage ] = useState(null);
  const [ confirmMessage, setConfirmMessage ] = useState(null);
  const gamesRef = useRef({});
  const approveRef = useRef();

  useEffect(() => {
    if (!show) {
      gamesRef.current = {};
      setGameList({});
      setSelectedGames([]);
      return;
    };
    getOtherGames();
  }, [show])

  async function getOtherGames() {
    getRegsFromDb({
      'appId': userProfile.appId,
      'status': 'active',
      'once': true,
      'callback': callback
    })
    function callback(data) {
      console.log(data);
      const obj = {};
      Object.values(data).forEach(g => {
        if (g.gameId === element.gameId) return;
        const roles = g.roles[userProfile.appId] || [];
        let role;
        if (!roles.includes('owner') && !roles.includes('manager')) return;
        if (roles.includes('owner')) {
          role = 'Owner';
        } else {
          role = 'Manager';
        }
        obj[g.gameId] = g;
        getGameData(g.gameId, role);
      })
    }
  }

  function getGameData(gameId, role) {
    console.log(gameId);
    getUniqueDocumentFromDb({
      'collection': 'games',
      'docId': gameId,
      'callback': callback,
      'once': true
    })
    function callback(data) {
      console.log(data);
      data.userRole = role;
      gamesRef.current = {
        ...gamesRef.current,
        [gameId]: data
      }
      setGameList(gamesRef.current);
    }
  }

  function initiateCopy() {
    setConfirmMessage(`Are you sure you want to copy this element to the ${selectedGames.length} selected game(s)? 
      This action can only be undone by going into each game and deleting the copied element.`);
    approveRef.current = async () => {
      continueCopy();
    }

    async function continueCopy() {
      setLoading(true);
      const res = await UseCloudFunction(
        'copyGameElementToOtherGames',
        {
          'appId': userProfile.appId,
          'elementPath': `games/${element.gameId}/gameElements/${element.id}`,
          'targetGameIds': selectedGames,
          'userName': `${userProfile.fName} ${userProfile.lName}`
        }
      )
      console.log(res);
      setLoading(false);
      if (res.error) {
        setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
        return;
      }
      setAlertMessage(`Element copied successfully to ${selectedGames.length} game(s).`);
      approveRef.current = () => {
        setSelectedGames([]);
        setLoading(false);
        cancel();
        return;
      }
    }
  }

  return (
    <div className='copy-to-games-modal'>
      <Modal
        show={show}
        cancel={cancel}
        closeButton={true}
        text="Copy Element to Other Games" >
        <div className='copy-to-games-modal-content'>
          <p>Select the games you would like to copy this element to. 
            The element will be copied to the same location in each 
            game as it is in the current game. 
            For example, if you are copying a level element, 
            it will be copied to the same level in each selected game.
          </p>
          <div className='game-list'>
          {
            (Object.values(gameList).length === 0)
            ?
            <div className='meta'><i>You do not manage any other games.</i></div>
            :
            Object.values(gameList).map(g => {
              if (g.gameId === element.gameId) return null;
              return (
                <div key={g.gameId} className='game-item field-checkbox'>
                  <input 
                    type='checkbox'
                    id={`copy-game-${g.gameId}`} 
                    checked={selectedGames.includes(g.gameId)}
                    onChange={() => {
                      if (selectedGames.includes(g.gameId)) {
                        setSelectedGames(selectedGames.filter(id => id !== g.gameId));
                      } else {
                        setSelectedGames([...selectedGames, g.gameId]);
                      }
                    }} />
                  <label htmlFor={`copy-game-${g.gameId}`}>
                    <ImageContainer src={g.icon} className='game-icon' />
                    {g.gameName}
                    <span className='meta'>{`(${g.userRole})`}</span>
                  </label>
                </div>
              )
            })}
          </div>
          <div className="g-space-1"></div>
            <div className='buttons'>
              <button
                className='g-button '
                onClick={cancel}>
                Cancel
              </button>
              <button
                className='g-button '
                onClick={() => initiateCopy()}>
                Copy Element to Selected Games
              </button>
            </div>
        </div>
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
        onApprove={approveRef.current} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader show={loading} />
    </div>
  )
}

export default CopyToGamesModal